import { API, unwrapData } from '../axios-instance'
import {
  AwardRefinement,
  CardSigningRefinement,
  CreateAwardRefinementParams,
  CreateCardSigningRefinementParams,
  CreateNominationRefinementParams,
  CreateRecognitionRefinementParams,
  NominationRefinement,
  RecognitionRefinement,
} from './types'

export const createRecognitionRefinement = async (params: CreateRecognitionRefinementParams) => {
  return await API.post<RecognitionRefinement>('/refinement/refinements/recognition', params).then(
    unwrapData,
  )
}

export const createAwardRefinement = async (params: CreateAwardRefinementParams) => {
  return await API.post<AwardRefinement>('/refinement/refinements/award', params).then(unwrapData)
}

export const createNominationRefinement = async (params: CreateNominationRefinementParams) => {
  return await API.post<NominationRefinement>('/refinement/refinements/nomination', params).then(
    unwrapData,
  )
}

export const createCardSigningRefinement = async (params: CreateCardSigningRefinementParams) => {
  return await API.post<CardSigningRefinement>('/refinement/refinements/cardSigning', params).then(
    unwrapData,
  )
}

export const deleteRefinement = async (refinementId: string) => {
  return await API.delete<boolean>(`/refinement/refinements/${refinementId}`)
}
